module.exports = __webpack_public_path__ + "img/canvas.72b2a466.svg";